// import "./prototypes";

// import { WbAccordions } from "./modules/WbAccordions";

// document.addEventListener("readystatechange", (event) => {
//   if (document.readyState == "complete") {
//     /**
//      * ALL OF THESE ARE GLOBALS
//      * DO NOT IMPORT IN A DIFFERENT MODULE
//      */
//     window.WbAccordions = new WbAccordions();
//   }
// });
console.log("webit");
import "./prototypes/top-nav";
import "./prototypes/header";
import "./prototypes/general";
